/**
 * data_coach/api.js — Data Coach API helpers
 * Wraps all /data-coach/... backend calls.
 */

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';

async function _post(path, body, token) {
  const res = await fetch(`${API}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }));
    const e = new Error(
      typeof err.detail === 'string'
        ? err.detail
        : err.detail?.message || `HTTP ${res.status}`
    );
    e.status = res.status;
    if (res.status === 429 && typeof err.detail === 'object') {
      e.rateLimitInfo = err.detail;  // { code, message, used, limit, tier }
    }
    throw e;
  }
  return res.json();
}

async function _get(path, token) {
  const res = await fetch(`${API}${path}`, {
    headers: { ...(token && { Authorization: `Bearer ${token}` }) },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
  return res.json();
}

// `token` is the caller's Supabase access_token (omit/undefined for the
// public demo user — the backend only accepts an unauthenticated call for
// that one fixed demo account, see data_coach_routes.py's DEMO_USER_ID check).
export const dataCoachApi = {
  chat:            (userId, message, history, token, sport) => _post('/data-coach/chat', { user_id: userId, message, history: history || [], sport: sport || null }, token),
  getChatHistory:  (userId, token)    => _get(`/data-coach/chat/history/${userId}`, token),
};
